export const QUESTION_TYPE_TESTS_PER_PAGE = 5;

export const paginateQuestionTypeTests = (tests = [], requestedPage = 1) => {
  const pageCount = tests.length === 0
    ? 0
    : Math.ceil(tests.length / QUESTION_TYPE_TESTS_PER_PAGE);
  const page = pageCount === 0
    ? 1
    : Math.min(Math.max(Number(requestedPage) || 1, 1), pageCount);
  const start = (page - 1) * QUESTION_TYPE_TESTS_PER_PAGE;

  return {
    items: tests.slice(start, start + QUESTION_TYPE_TESTS_PER_PAGE),
    page,
    pageCount,
  };
};
